import React, { useContext, useEffect, useState } from 'react';
import ProductContext from './ProductContext.jsx';
import Drawer from './Drawer.jsx';
import SVG from './SVG.jsx';
import { formatMoney } from '@shopify/theme-currency';
// import loadjs from 'loadjs';

export default function AfterPay(props) {
  const [open, setOpen] = useState(false);
  const context = useContext(ProductContext);
  const afterPayAmount = props.productPrice / 4;
  let format = window.Theme.moneyFormat;
  if ((afterPayAmount / 100 | 0) < afterPayAmount / 100) {
    format = window.Theme.moneyFormatDecimals;
  }

  const _open = (e) => {
    e.preventDefault();
    setOpen(true);
  }

  /* const renderPaypal = async () => {
    const paypalEl = document.querySelector('.afterpay-drawer .paypal');
    if (paypalEl && open) {
      if (!window.paypal || !window.paypal.Messages) {
        await loadjs('https://www.paypal.com/sdk/js?client-id=AQbIP2GTacHjDehn5O-8u6WeLFH7FAJyBVfQAONFCRfXmdW5PQtdr1ovc_vA2biFOlI_k620FwKVsEM4&components=messages', { returnPromise: true });
      }
      paypalEl.setAttribute('data-pp-amount', props.productPrice / 100);
      window.paypal.Messages().render('.afterpay-drawer .paypal');
    }
  }

  useEffect(() => {
    renderPaypal();
  }, [open]); */

  return <div className="afterpay">
    {props.alternatePriceLayout ?
      <span>4 payments of <span className="money" dangerouslySetInnerHTML={{ __html: formatMoney(props.productPrice / 4, format) }}></span> with </span>
      :
      <span>or 4 payments of <span className="money" dangerouslySetInnerHTML={{ __html: formatMoney(props.productPrice / 4, format) }}></span> by </span>
    }
    <span class="bnpl-logos">
      <SVG icon="ap-logo" />
      or
      <SVG icon="afterpay" />
    </span>
    <span class="ap-only">
      <SVG icon="ap-logo" />
    </span>
    <span class="kl-only">
      <SVG icon="afterpay" />
    </span>
    <a href="#" aria-label="Info" onClick={_open}>
      <SVG icon="info" />
    </a>
    <Drawer open={open} contentClass='afterpay-drawer' content={context.productSettings.afterPayDetails} _close={() => setOpen(false)} mountOnEnter={false} unmountOnExit={false} />
  </div>
}
